import React from 'react';

const NotFound = () => {
    
    return (
        <div>
            <h1>Sorry the page you are looking for is not available :(</h1>
        </div>
    );
};

export default NotFound;